import {sanitizeDisplayName} from '#/lib/strings/display-names'
import {displayAtproto} from '#/lib/strings/identifiers'

export function getUserDisplayName<
  T extends {displayName?: string; handle: string; [key: string]: any},
>(props: T): string {
  return sanitizeDisplayName(props.displayName || displayAtproto(props.handle))
}
